export enum NavigationActionTypes {
  SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE',
  SET_FBMANAGER_PAGE_ACCESS = 'SET_FBMANAGER_PAGE_ACCESS',
  MAIN_MENU_COLLAPSED = 'MAIN_MENU_COLLAPSED',
}

interface ISetCurrentRouteAction {
  type: NavigationActionTypes.SET_CURRENT_ROUTE;
  payload: string;
}

interface ISetFBManagerPageAccess {
  type: NavigationActionTypes.SET_FBMANAGER_PAGE_ACCESS;
  payload: boolean;
}

interface IIsMainMenuCollapsedAction {
  type: NavigationActionTypes.MAIN_MENU_COLLAPSED;
  payload: boolean;
}

export type TNavigationActions =
  | ISetCurrentRouteAction
  | ISetFBManagerPageAccess
  | IIsMainMenuCollapsedAction;

export const setCurrentNavigationRoute = (payload: string): TNavigationActions => ({
  type: NavigationActionTypes.SET_CURRENT_ROUTE,
  payload,
});

export const setFBManagerPageAccess = (payload: boolean): TNavigationActions => ({
  type: NavigationActionTypes.SET_FBMANAGER_PAGE_ACCESS,
  payload,
});

export const isMainMenuCollapsed = (payload: boolean): TNavigationActions => ({
  type: NavigationActionTypes.MAIN_MENU_COLLAPSED,
  payload,
});
